/**
 * @generated SignedSource<<673b6198258e094e8ab9597b3c4852b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCreateToolbar_data$data = {
  readonly teamsByIds: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTeams_teams">;
  } | null> | null;
  readonly " $fragmentType": "TodoCreateToolbar_data";
};
export type TodoCreateToolbar_data$key = {
  readonly " $data"?: TodoCreateToolbar_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCreateToolbar_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "teamIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoCreateToolbar_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "ids",
          "variableName": "teamIds"
        }
      ],
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teamsByIds",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoToolbarButtonTeams_teams"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f8f383154aa5aa888a9a0c0de17ce673";

export default node;
